"use strict";

(function (Drupal, once, window) {
  Drupal.behaviors.expose_anchor = {
    attach: function attach(context, settings) {
      var anchorExpose = function anchorExpose(linkHash) {
        var hash = window.location.hash;
        if (linkHash !== undefined) {
          hash = linkHash;
        }
        hash = hash.substring(1);
        if (hash.length !== 0) {
          // Ensure hash is a valid selector
          try {
            var anchor = document.getElementById(hash);
            if (anchor) {
              var elementOffset = anchor.getBoundingClientRect().top + window.scrollY;
              var windowWidth = window.innerWidth;
              var headerOffset = 130;
              if (windowWidth < 415) {
                headerOffset = 355;
              } else if (windowWidth < 316) {
                headerOffset = 300;
              }

              // Account for admin menu for logged in users.
              var toolbar = document.getElementsByClassName('gin-secondary-toolbar--frontend');
              if (toolbar !== undefined && toolbar.length !== 0) {
                headerOffset += 60;
              }
              var offsetPosition = elementOffset - headerOffset;
              window.setTimeout(function () {
                window.scrollTo(0, offsetPosition);
              }, 100);
            } else {
              console.log('Element not found for hash: ' + hash);
            }
          } catch (error) {
            console.error('Invalid selector:', error);
          }
        }
      };
      var hash = window.location.hash;
      if (hash !== undefined && hash.length !== 0) {
        anchorExpose(hash);
      }
      once('anchorProcessed', 'a', context).forEach(function (element) {
        element.addEventListener('click', function (event) {
          var url = element.getAttribute('href');
          if (url !== '#' && url !== '') {
            var hashParts = url.split('#');
            if (hashParts.length > 1) {
              var _hash = hashParts.pop();
              window.setTimeout(function () {
                anchorExpose('#' + _hash);
              }, 100);
            }
          }
        });
      });
    }
  };
})(Drupal, once, window);